/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {SearchGridCardSkeleton} from "../../search/SearchGridCardSkeleton";

export const SearchFinderRowSkeleton = () => (
    <>{[...Array(4)].map((item, i) => <SearchGridCardSkeleton key={i}/>)}</>
)
